import React, { useState } from 'react';
import FaqHeading from '../components/faqHeading';

const faqData = [
  {
    question: 'How does pixa work?',
    answer:
      'Download pixa app from App/Play Store & follow instructions to connect pixa to your Wi-Fi network. Once connected, you would be able to interact by simply saying “Hey pixa”',
  },
  {
    question: 'How pixa ensures safe conversations?',
    answer:
      'Pixa follows tight guardrails to ensure safe conversations for kids, and molds conversation to safer system whenever a kid tries to talk about something inappropriate.',
  },
  {
    question: "Can parents monitor their child's conversations with Pixa?",
    answer:
      'Yes, we built our app to give parents superpowers to moniter conversations & design educational experiences for their kids.',
  },
  {
    question: 'What languages are currently supported?',
    answer:
      'Currently we support English, Chinese, Spanish, French & German as primary languages. We are adding support for more.',
  },
];

function Faq() {
  const [answersVisibility, setAnswersVisibility] = useState<boolean[]>(
    new Array(faqData.length).fill(false)
  );

  const updateAnswerVisibility = (index: number) => {
    setAnswersVisibility((prevVisibility) => {
      const newVisibility = [...prevVisibility];
      newVisibility[index] = !newVisibility[index];
      return newVisibility;
    });
  };

  return (
    <div className="flex flex-col items-center justify-center text-center relative py-[4.5rem] space-y-8 max-lg:space-y-12 max-sm:space-y-8">
      <FaqHeading />
      <div className="w-[90%] justify-center items-center flex">
        <div className="w-[90%] max-sm:w-full flex flex-col justify-start items-center my-[24px] xxl:my-6 rounded-[3rem] max-sm:rounded-[2.2rem] border-2 overflow-hidden border-[#1B1717]">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="flex flex-col w-full border-b-2 bg-footer border-[#1B1717] min-h-32 xxl:min-h-36 max-md:min-h-24 p-8 max-sm:p-4 hover:cursor-pointer"
              onClick={() => updateAnswerVisibility(index)}
            >
              <div
                className="flex flex-row items-center justify-between text-left max-lg:space-x-1 hover:cursor-pointer"
                // onClick={() => updateAnswerVisibility(index)}
              >
                <span className="font-semibold text-white text-2xl xxl:text-4xl max-lg:text-xl max-md:text-sm flex flex-row justify-start items-center text-left space-x-4 py-4 w-[90%] ">
                  <span
                    className={`text-3xl xxl:text-5xl max-lg:text-2xl max-md:text-xl text-[#9D96A8] ${
                      index + 1 === 1 ? 'mr-8 max-sm:mr-6' : 'mr-6 max-sm:mr-5'
                    }`}
                  >
                    0{index + 1}
                  </span>
                  {faq.question}
                </span>
                {answersVisibility[index] ? (
                  <img
                    src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723784304/pixa-pie/faq/cross.png"
                    alt="plus"
                    className="w-6 h-6 xxl:h-12 xxl:w-12 hover:cursor-pointer"
                  />
                ) : (
                  <img
                    src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723784304/pixa-pie/faq/plus.png"
                    alt="plus"
                    className="w-6 h-6 xxl:h-12 xxl:w-12 hover:cursor-pointer"
                  />
                )}
              </div>
              <div className="w-full flex max-sm:justify-center lg:justify-start text-left items-center">
                <div
                  className={`w-[80%] text-xl xxl:text-3xl max-lg:text-lg max-md:text-sm text-white/70 text-left flex justify-start items-center px-[1.1rem] lg:px-[4.2rem] xxl:px-[5.4rem] ${
                    answersVisibility[index] ? '' : 'hidden'
                  }`}
                >
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default React.memo(Faq);
